export function formatPrecio(valor) {
  const numero = parseFloat(valor) || 0;
  return numero.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  });
}